import React from "react";
import { useSelector } from "react-redux";
import ColorBox from "./UI/ColorBox";
import Row from "./UI/Row";

const WageDisplay = ({ title, location, wage, per, hasData }) => (
  <ColorBox color="darkGrey" className="margin-right-2">
    <p>
      {title} {location && <strong>{location}</strong>}:
    </p>
    <p>
      <strong>
        {hasData && wage && per
          ? `$${wage} per ${per}`
          : hasData
          ? "Select a 'Per' Option below."
          : `No ${
              location ? `data for ${location}` : "Federal Wage data"
            }. Please refresh your browser.`}
      </strong>
    </p>
  </ColorBox>
);

const MinimumWageDisplay = ({
  formValues,
  schemaProps: {
    minimum_wage_display: {
      based_on,
      state_field,
      state,
      state_per,
      federal,
      federal_per,
    },
  },
}) => {
  const { stateMinWages, federalMinWage } = useSelector(
    (state) => state.referenceReducer
  );

  const hasStateMinWages = Object.keys(stateMinWages).length > 0;
  const hasFederalMinWages = Object.keys(federalMinWage).length > 0;

  return (
    <ColorBox>
      <h4>Minimum Wage Calculations</h4>
      <p>
        <small>
          View minimum wages based on values entered for fields {based_on[0]}{" "}
          (state) and {based_on[1]} (per)
        </small>
      </p>
      {formValues[state_field] && (
        <Row>
          {state && (
            <WageDisplay
              title="State Minimum Wage for"
              location={formValues[state_field]}
              wage={formValues[state]}
              per={formValues[state_per]}
              hasData={hasStateMinWages}
            />
          )}
          {federal && (
            <WageDisplay
              title="Federal Minimum Wage"
              wage={formValues[federal]}
              per={formValues[federal_per]}
              hasData={hasFederalMinWages}
            />
          )}
        </Row>
      )}
    </ColorBox>
  );
};

export default MinimumWageDisplay;
